import React, { useState } from 'react';
import me from '../../../assets/me.JPG';
import {
    BrowserRouter as Router, Switch, Route, Link , useHistory
  } from "react-router-dom";

function ViewMyIntroduction(props) {
    const [ myPhotoModal, setMyPhotoModal ] = useState(false);
    const toggleMyPhotoModal = () => setMyPhotoModal(!myPhotoModal);   

    var history = useHistory();
    const onNavigate = (o) => {
      history.push(o)
    }
    return (
    <div className="row pd-l-5 pd-r-5 ">
        <div className="wd-pct-33 pd-r-0">
            <div className="profile-card b-l-border b-t-border b-b-border">
                <div className="row pd-20">
                    <img alt="EAI" src={me} style={{height: '160px'}} className="img-radius-50 pd-l-5 c-pointer" onClick={toggleMyPhotoModal} />                            
                    
                    <div className=" pd-r-25">
                        <div className="category-box-content mg-l-20 pd-t-45">
                            <h3>Susmita Chaudhury</h3>
                            <p>Analytics Innovation</p>
                            <div className="profile-location">Bengaluru, India</div>
                        </div>
                    </div>
                </div>
                        <div className="row transaction-footer">                        
                            <div className="col-md-6 b-t-border b-r-border " >
                            Copy Url
                            </div>
                            <div className="col-md-6 b-t-border" onClick={() => onNavigate("profile")} >Edit Profile</div>                            
                        </div>
                    </div>
        </div>
        <div className="wd-pct-27 pd-l-0">
            <div className="profile-card-dark">
                <div className="profile-card-dark-header">
                    <div className="profile-card-dark-header-left">
                                <h5>Cover Message</h5>
                    </div>                        
                    <div className="profile-card-dark-header-right">
                                <i className="far fa-play-circle"  ></i>
                                
                    </div>
                </div>
                <div className="profile-card-dark-block p-t-0">
                            I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful.
                </div>
            </div>
        </div>
        <div className="wd-pct-1"></div>
        <div className="wd-pct-39">
            <div className="card ht-250 mg-b-0" >
                <div  style={{margin:'auto'}} className="wd-pct-100 pd-l-25 pd-r-25">
                    <div className="v-align b-b-border pd-b-10" >
                        <h5 className="wd-pct-40" >Expertise Area</h5>
                        <div className="wd-pct-60" >Web & Software Development</div>
                    </div>
                    <div className="v-align b-b-border pd-t-10 pd-b-10" >
                        <h5 className="wd-pct-40" >Current Position</h5>
                        <div className="wd-pct-60" >Executive Vice President</div>
                    </div>
                    <div className="v-align b-b-border pd-t-10 pd-b-10" >
                        <h5 className="wd-pct-40" >Qualification</h5>
                        <div className="wd-pct-60" >Masters, Economics</div>
                    </div>
                    <div className="v-align pd-t-10" >
                        <h5 className="wd-pct-40" >Date of Birth</h5>
                        <div className="wd-pct-60" >December 9, 1974</div>
                    </div>
                </div>
            </div>
        </div>
        
        
    </div>
        
    );
  }

export default ViewMyIntroduction